import styled, { css } from 'styled-components';

import { Accordion } from '@sternum/ui';
import { Icon } from '@sternum/web/components/Icon';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const NestedAccordionStyled = styled(Accordion)`
  margin: 0;

  // first item in accordion is the title with the collapse icon
  & > div:first-child {
    align-items: center;
    border-radius: 4px;

    &:hover {
      background-color: ${ct({ Light: Colors.Lighter, Dark: Colors.Lighter })};
    }

    & > div:first-child {
      height: 100%;
      padding-right: 0;
    }
  }

  // second item in accordion is the nested content
  & > div:nth-child(2) > div > div {
    display: flex;
    flex-direction: row-reverse;
  }
`;

export const NestedAccordionTitle = styled.div`
  flex: 1;
  width: calc(100% - 18px);
`;

export const AccordionContentStyled = styled.div`
  margin: 0;
  padding: 0;
  width: calc(100% - 40px);
`;

export const NestIconStyled = styled(Icon)`
  position: absolute;
  top: 0;
  left: 28px;
  width: fit-content;
`;

export const IconStyled = styled(Icon)<{ $isExpanded: boolean; $isVisible: boolean }>`
  transition: transform 0.2s ease-in-out;

  ${(props) =>
    !props.$isVisible &&
    css`
      opacity: 0;
      pointer-events: none;
    `};

  ${(props) =>
    !props.$isExpanded &&
    css`
      transform: rotate(90deg);
    `};
`;
